import Vue from 'vue'

import "./bootstrap"
import "./helpers"
import "./sentry"


if (process.env.NODE_ENV !== "production") {
    Vue.config.devtools = true;
}

require('./modules');